import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import DialPad from './DialPad';

function CheckIn({ orgId }) {
  const [childName, setChildName] = useState('');
  const [parentName, setParentName] = useState('');
  const [parentPhone, setParentPhone] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleCheckIn = async () => {
    setMessage('');
    setError('');

    if (!childName || !parentName || !parentPhone) {
      setError('Please fill in all fields.');
      return;
    }

    const { data, error } = await supabase
      .from('children')
      .insert([{ full_name: childName, parent_name: parentName, parent_phone: parentPhone, organization_id: orgId }])
      .select();

    if (error) {
      setError('Error: ' + error.message);
      return;
    }

    await supabase
      .from('checkins')
      .insert([{ child_id: data[0].id, organization_id: orgId, status: 'checked_in', checked_in_at: new Date() }]);

    setMessage(`✅ ${childName} has been checked in successfully!`);
    setChildName('');
    setParentName('');
    setParentPhone('');
  };

  return (
    <div>
      <div className="header">
        <h2>👶 Child Check-In</h2>
        <p>Enter child and parent details below</p>
      </div>

      <input className="input" placeholder="Child's Full Name" value={childName} onChange={(e) => setChildName(e.target.value)} />
      <input className="input" placeholder="Parent's Full Name" value={parentName} onChange={(e) => setParentName(e.target.value)} />
      <p style={{ textAlign: 'center', fontWeight: '600', marginBottom: '8px', color: '#444' }}>Parent's Phone Number</p>
      <DialPad value={parentPhone} onChange={setParentPhone} maxLength={10} />

      <button className="btn btn-primary" onClick={handleCheckIn}>Check In Child</button>

      {message && <div className="success-message">{message}</div>}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
}

export default CheckIn;